import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, getUser, getUserPlatform, remove, update, updatePlatform, add, grant, resetPassword } from "@/api/system/user";
import { getDeptTree, getDeptLazyTree } from "@/api/system/dept";
import { getRoleTree } from "@/api/system/role";
import { getPostList } from "@/api/system/post";
import { mapGetters } from "vuex";
import website from '@/config/website';
import { getToken } from '@/util/auth';
export default {
  data: function data() {
    var _this = this;

    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      form: {},
      search: {},
      roleBox: false,
      excelBox: false,
      platformBox: false,
      initFlag: true,
      selectionList: [],
      query: {},
      loading: true,
      platformLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      init: {
        roleTree: [],
        deptTree: []
      },
      props: {
        label: "title",
        value: "key"
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        lazy: true,
        treeLoad: function treeLoad(node, resolve) {
          var parentId = node.level === 0 ? 0 : node.data.id;
          getDeptLazyTree(parentId).then(function (res) {
            resolve(res.data.data.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                leaf: !item.hasChildren
              });
            }));
          });
        },
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children'
        }
      },
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        //dialogType: 'drawer',
        dialogClickModal: false,
        column: [{
          label: "登录账号",
          prop: "account",
          search: true,
          display: false
        }, {
          label: "所属租户",
          prop: "tenantName",
          slot: true,
          display: false
        }, {
          label: "用户姓名",
          prop: "realName",
          search: true,
          display: false
        }, {
          label: "所属角色",
          prop: "roleName",
          slot: true,
          display: false
        }, {
          label: "所属部门",
          prop: "deptName",
          slot: true,
          display: false
        }, {
          label: "用户平台",
          prop: "userTypeName",
          slot: true,
          display: false
        }, {
          label: "用户平台",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=user_type",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          search: true,
          hide: true,
          display: false,
          prop: "userType",
          rules: [{
            required: true,
            message: "请选择用户平台",
            trigger: "blur"
          }]
        }],
        group: [{
          label: '基础信息',
          prop: 'baseInfo',
          icon: 'el-icon-user-solid',
          column: [{
            label: "所属租户",
            prop: "tenantId",
            type: "tree",
            dicUrl: "/api/blade-system/tenant/select",
            props: {
              label: "tenantName",
              value: "tenantId"
            },
            hide: !website.tenantMode,
            addDisplay: website.tenantMode,
            editDisplay: website.tenantMode,
            viewDisplay: website.tenantMode,
            rules: [{
              required: true,
              message: "请输入所属租户",
              trigger: "click"
            }],
            span: 24
          }, {
            label: "登录账号",
            prop: "account",
            rules: [{
              required: true,
              message: "请输入登录账号",
              trigger: "blur"
            }]
          }, {
            label: "用户平台",
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=user_type",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "number",
            slot: true,
            prop: "userType",
            rules: [{
              required: true,
              message: "请选择用户平台",
              trigger: "blur"
            }]
          }, {
            label: '密码',
            prop: 'password',
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            rules: [{
              required: true,
              validator: validatePass,
              trigger: 'blur'
            }]
          }, {
            label: '确认密码',
            prop: 'password2',
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            rules: [{
              required: true,
              validator: validatePass2,
              trigger: 'blur'
            }]
          }]
        }, {
          label: '详细信息',
          prop: 'detailInfo',
          icon: 'el-icon-s-order',
          column: [{
            label: "用户昵称",
            prop: "name",
            hide: true,
            rules: [{
              required: true,
              message: "请输入用户昵称",
              trigger: "blur"
            }]
          }, {
            label: "用户姓名",
            prop: "realName",
            rules: [{
              required: true,
              message: "请输入用户姓名",
              trigger: "blur"
            }, {
              min: 2,
              max: 5,
              message: '姓名长度在2到5个字符'
            }]
          }, {
            label: "手机号码",
            prop: "phone",
            overHidden: true
          }, {
            label: "电子邮箱",
            prop: "email",
            hide: true,
            overHidden: true
          }, {
            label: "用户性别",
            prop: "sex",
            type: "select",
            dicData: [{
              label: "男",
              value: 1
            }, {
              label: "女",
              value: 2
            }, {
              label: "未知",
              value: 3
            }],
            hide: true
          }, {
            label: "用户生日",
            type: "date",
            prop: "birthday",
            format: "yyyy-MM-dd hh:mm:ss",
            valueFormat: "yyyy-MM-dd hh:mm:ss",
            hide: true
          }, {
            label: "账号状态",
            prop: "statusName",
            hide: true,
            display: false
          }]
        }, {
          label: '职责信息',
          prop: 'dutyInfo',
          icon: 'el-icon-s-custom',
          column: [{
            label: "用户编号",
            prop: "code"
          }, {
            label: "所属角色",
            prop: "roleId",
            multiple: true,
            type: "tree",
            dicData: [],
            props: {
              label: "title"
            },
            checkStrictly: true,
            slot: true,
            rules: [{
              required: true,
              message: "请选择所属角色",
              trigger: "click"
            }]
          }, {
            label: "所属部门",
            prop: "deptId",
            type: "tree",
            multiple: true,
            dicData: [],
            props: {
              label: "title"
            },
            checkStrictly: true,
            slot: true,
            rules: [{
              required: true,
              message: "请选择所属部门",
              trigger: "click"
            }]
          }, {
            label: "所属岗位",
            prop: "postId",
            type: "tree",
            multiple: true,
            dicData: [],
            props: {
              label: "postName",
              value: "id"
            },
            rules: [{
              required: true,
              message: "请选择所属岗位",
              trigger: "click"
            }]
          }]
        }]
      },
      data: [],
      platformQuery: {},
      platformSelectionList: [],
      platformData: [],
      platformForm: {},
      platformOption: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        dialogClickModal: false,
        menuWidth: 120,
        editBtnText: '配置',
        column: [{
          label: "登录账号",
          prop: "account",
          search: true,
          display: false
        }, {
          label: "所属租户",
          prop: "tenantName",
          slot: true,
          display: false
        }, {
          label: "用户姓名",
          prop: "realName",
          search: true,
          display: false
        }, {
          label: "用户平台",
          prop: "userTypeName",
          slot: true,
          display: false
        }, {
          label: "用户平台",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=user_type",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          search: true,
          hide: true,
          display: false,
          prop: "userType",
          rules: [{
            required: true,
            message: "请选择用户平台",
            trigger: "blur"
          }]
        }, {
          label: "用户拓展",
          prop: "userExt",
          type: "textarea",
          minRows: 8,
          span: 24,
          overHidden: true,
          row: true,
          hide: true
        }]
      },
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '模板上传',
          prop: 'excelFile',
          type: 'upload',
          drag: true,
          loadText: '模板上传中，请稍等',
          span: 24,
          propsHttp: {
            res: 'data'
          },
          tip: '请上传 .xls,.xlsx 标准格式文件',
          action: "/api/blade-user/import-user"
        }, {
          label: "数据覆盖",
          prop: "isCovered",
          type: "switch",
          align: "center",
          width: 80,
          dicData: [{
            label: "否",
            value: 0
          }, {
            label: "是",
            value: 1
          }],
          value: 0,
          slot: true,
          rules: [{
            required: true,
            message: "请选择是否覆盖",
            trigger: "blur"
          }]
        }, {
          label: '模板下载',
          prop: 'excelTemplate',
          formslot: true,
          span: 24
        }]
      }
    };
  },
  watch: {
    'form.tenantId': function formTenantId() {
      if (this.form.tenantId !== '' && this.initFlag) {
        this.initData(this.form.tenantId);
      }
    },
    'excelForm.isCovered': function excelFormIsCovered() {
      if (this.excelForm.isCovered !== '') {
        var column = this.findObject(this.excelOption.column, "excelFile");
        column.action = "/api/blade-user/import-user?isCovered=".concat(this.excelForm.isCovered);
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.user_add, false),
        viewBtn: this.vaildData(this.permission.user_view, false),
        delBtn: this.vaildData(this.permission.user_delete, false),
        editBtn: this.vaildData(this.permission.user_edit, false)
      };
    },
    platformPermissionList: function platformPermissionList() {
      return {
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: this.vaildData(this.permission.user_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  mounted: function mounted() {
    // 非租户模式默认加载管理组数据
    if (!website.tenantMode) {
      this.initData(website.tenantId);
    }
  },
  methods: {
    nodeClick: function nodeClick(data) {
      this.treeDeptId = data.id;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    initData: function initData(tenantId) {
      var _this2 = this;

      getRoleTree(tenantId).then(function (res) {
        var column = _this2.findObject(_this2.option.group, "roleId");

        column.dicData = res.data.data;
      });
      getDeptTree(tenantId).then(function (res) {
        var column = _this2.findObject(_this2.option.group, "deptId");

        column.dicData = res.data.data;
      });
      getPostList(tenantId).then(function (res) {
        var column = _this2.findObject(_this2.option.group, "postId");

        column.dicData = res.data.data;
      });
    },
    submitRole: function submitRole() {
      var _this3 = this;

      var roleList = this.$refs.treeRole.getCheckedKeys().join(",");
      grant(this.ids, roleList).then(function () {
        _this3.roleBox = false;

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        _this3.onLoad(_this3.page);
      });
    },
    rowSave: function rowSave(row, done, loading) {
      var _this4 = this;

      row.deptId = row.deptId.join(",");
      row.roleId = row.roleId.join(",");
      row.postId = row.postId.join(",");
      add(row).then(function () {
        _this4.initFlag = false;

        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this5 = this;

      row.deptId = row.deptId.join(",");
      row.roleId = row.roleId.join(",");
      row.postId = row.postId.join(",");
      update(row).then(function () {
        _this5.initFlag = false;

        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this6 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this6.onLoad(_this6.page);

        _this6.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this7 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this7.ids);
      }).then(function () {
        _this7.onLoad(_this7.page);

        _this7.$message({
          type: "success",
          message: "操作成功!"
        });

        _this7.$refs.crud.toggleSelection();
      });
    },
    handleReset: function handleReset() {
      var _this8 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择账号密码重置为123456?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return resetPassword(_this8.ids);
      }).then(function () {
        _this8.$message({
          type: "success",
          message: "操作成功!"
        });

        _this8.$refs.crud.toggleSelection();
      });
    },
    handleGrant: function handleGrant() {
      var _this9 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.roleTreeObj = [];

      if (this.selectionList.length === 1) {
        this.roleTreeObj = this.selectionList[0].roleId.split(",");
      }

      getRoleTree().then(function (res) {
        _this9.roleGrantList = res.data.data;
        _this9.roleBox = true;
      });
    },
    handlePlatform: function handlePlatform() {
      this.platformBox = true;
    },
    handleImport: function handleImport() {
      this.excelBox = true;
    },
    uploadAfter: function uploadAfter(res, done, loading, column) {
      window.console.log(column);
      this.excelBox = false;
      this.refreshChange();
      done();
    },
    handleExport: function handleExport() {
      var _this10 = this;

      this.$confirm("是否导出用户数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        window.open("/api/blade-user/export-user?".concat(_this10.website.tokenHeader, "=").concat(getToken(), "&account=").concat(_this10.search.account, "&realName=").concat(_this10.search.realName));
      });
    },
    handleTemplate: function handleTemplate() {
      window.open("/api/blade-user/export-template?".concat(this.website.tokenHeader, "=").concat(getToken()));
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this11 = this;

      if (["edit", "view"].includes(type)) {
        getUser(this.form.id).then(function (res) {
          _this11.form = res.data.data;

          if (_this11.form.hasOwnProperty("deptId")) {
            _this11.form.deptId = _this11.form.deptId.split(",");
          }

          if (_this11.form.hasOwnProperty("roleId")) {
            _this11.form.roleId = _this11.form.roleId.split(",");
          }

          if (_this11.form.hasOwnProperty("postId")) {
            _this11.form.postId = _this11.form.postId.split(",");
          }
        });
      }

      this.initFlag = true;
      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this12 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query), this.treeDeptId).then(function (res) {
        var data = res.data.data;
        _this12.page.total = data.total;
        _this12.data = data.records;
        _this12.loading = false;

        _this12.selectionClear();
      });
    },
    platformRowUpdate: function platformRowUpdate(row, index, done, loading) {
      var _this13 = this;

      updatePlatform(row.id, row.userType, row.userExt).then(function () {
        _this13.platformOnLoad(_this13.platformPage);

        _this13.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    platformBeforeOpen: function platformBeforeOpen(done, type) {
      var _this14 = this;

      if (["edit", "view"].includes(type)) {
        getUserPlatform(this.platformForm.id).then(function (res) {
          _this14.platformForm = res.data.data;
        });
      }

      done();
    },
    platformSearchReset: function platformSearchReset() {
      this.platformQuery = {};
      this.platformOnLoad(this.platformPage);
    },
    platformSearchChange: function platformSearchChange(params, done) {
      this.platformQuery = params;
      this.platformPage.currentPage = 1;
      this.platformOnLoad(this.platformPage, params);
      done();
    },
    platformSelectionChange: function platformSelectionChange(list) {
      this.platformSelectionList = list;
    },
    platformSelectionClear: function platformSelectionClear() {
      this.platformSelectionList = [];
      this.$refs.platformCrud.toggleSelection();
    },
    platformCurrentChange: function platformCurrentChange(currentPage) {
      this.platformPage.currentPage = currentPage;
    },
    platformSizeChange: function platformSizeChange(pageSize) {
      this.platformPage.pageSize = pageSize;
    },
    platformRefreshChange: function platformRefreshChange() {
      this.platformOnLoad(this.platformPage, this.platformQuery);
    },
    platformOnLoad: function platformOnLoad(page) {
      var _this15 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.platformLoading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query), this.treeDeptId).then(function (res) {
        var data = res.data.data;
        _this15.platformPage.total = data.total;
        _this15.platformData = data.records;
        _this15.platformLoading = false;

        _this15.selectionClear();
      });
    }
  }
};